export enum FORBIDDEN_ACTION {
  MANAGE_OWN_APPOINTMENTS = 'MANAGE_OWN_APPOINTMENTS',
  MANAGE_OTHERS_APPOINTMENTS = 'MANAGE_OTHERS_APPOINTMENTS',
}
